import { createBrowserRouter } from "react-router-dom";

import Landing from "./shared/landing";
import { ParticiparComunidadeEmBreve } from "./pages/participar-comunidade-em-breve";
import { ErrorPage } from "./pages/error";
import { ParticiparComunidade } from "./pages/participar-comunidade";
import { PoliticaPrivacidade } from "./pages/politica-privacidade";
import { DiagnosticoInicial } from "./pages/diagnostico-inicial";
import { DiagnosticoInicialEmBreve } from "./pages/diagnostico-inicial-em-breve";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Landing />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/participar-comunidade",
          element: <ParticiparComunidade />,
        },
        {
          path: "/politica-de-privacidade",
          element: <PoliticaPrivacidade />,
        },
        {
          path: "/participar-comunidade/em-breve",
          element: <ParticiparComunidadeEmBreve />,
        },
        {
          path: "/diagnostico-inicial",
          element: <DiagnosticoInicial />,
        },
         {
          path: "/diagnostico-inicial/em-breve",
          element: <DiagnosticoInicialEmBreve />,
        },
      ],
    },
    // {
    //   path: "/",
    //   element: <Main />,
    //   errorElement: <ErrorPage />,
    //   children: [
    //     {
    //       path: "/home",
    //       element: <HomePage />,
    //     },
    //   ],
    // },
  ],
  {
    // basename: process.env.NODE_ENV === "development" ? "" : "/squad-board/",
  }
);

export default router;
